package com.appsyde.shared.presentation.style.style

import com.appsyde.shared.presentation.style.animations.AppStylesAnimations
import com.appsyde.shared.presentation.style.token.AppStylesTokens
import com.appsyde.shared.presentation.style.token.AppStylesTokens.FONT_FAMILY
import io.ktor.http.CacheControl
import org.jetbrains.compose.web.css.*

object AppStylesMessages : StyleSheet() {

    init {
        // Placeholder : couleur muted + italic pour bien le distinguer du contenu
        "#answer-edit-area::placeholder" style {
            color(rgba(152, 162, 179, 1))
            property("font-style", "italic")
        }
    }

    val clientMessageMeta by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(6.px)
        fontSize(12.px)
        color(rgba(15, 23, 42, 0.62))
        marginBottom(8.px)
    }

    val metaSeparator by style {
        opacity(0.45)
    }

    val clientMetaTag by style {
        //color(rgba(102, 96, 230, 0.82))

        fontWeight(550)
    }
    val clientMetaTime by style {
        fontWeight(400)
    }

    val messageList by style {
        display(DisplayStyle.Flex)
        property("overflow-anchor", "none")
        flexDirection(FlexDirection.Column)
        gap(18.px)
    }

    val messageRow by style {
        display(DisplayStyle.Flex)
        gap(16.px)
        alignItems(AlignItems.FlexStart)
    }

    /** Ligne contenant la zone de saisie : espace supplémentaire au-dessus uniquement */
    val messageRowDraft by style {
        marginTop(4.px)
    }

    val messageColumn by style {
        flex(1)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
        minWidth(0.px)
    }

    val clientMetaLine by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(2.px)
        marginTop(2.px)
        minWidth(0.px)
    }

    val clientEmail by style {
        color(rgba(31, 41, 55, 0.80))
        fontWeight(550)
        fontSize(13.px)
        lineHeight(16.px)
        property("max-width", "520px")
        overflow("hidden")
        property("text-overflow", "ellipsis")
        whiteSpace("nowrap")
    }

    val avatarClient by style {
        width(32.px)
        height(32.px)
        borderRadius(12.px)
        backgroundColor(rgba(102, 96, 230, 0.08))
        property("border", "1px solid rgba(102,96,230,0.16)")
        color(rgba(72, 62, 200, 0.95))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        fontWeight(700)
        fontSize(13.px)
        flexShrink(0)
    }

    val avatarAI by style {
        width(32.px)
        height(32.px)
        borderRadius(12.px)
        backgroundColor(rgba(102, 96, 230, 0.08))
        property("border", "1px solid rgba(102,96,230,0.20)")
        color(rgba(102, 96, 230, 0.72))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        flexShrink(0)
    }

    val avatarIconSvg by style {
        width(14.px)
        height(14.px)
        display(DisplayStyle.Block)
    }

    val bubbleClient by style {
        width(100.percent)
        borderRadius(16.px)
        border(1.px, LineStyle.Solid, rgba(15, 23, 42, 0.12))
        padding(16.px, 18.px)
        property("box-shadow", AppStylesTokens.SHADOW_BUBBLE_CLIENT)
    }

    /** Fond zone client (bulles inbound). */
    val bubbleClientBg by style {
        property("background", "#FFFFFF")
    }

    val bubbleAI by style {
        width(100.percent)
        borderRadius(16.px)
        padding(16.px, 18.px)
        property("padding-left", "20px")
        position(Position.Relative)
        overflow("hidden")
        backgroundColor(Color("#F3F2FF"))//rgba(248, 247, 255, 0.80))
         border(1.px, LineStyle.Solid, Color("#E8E7FF"))
        property("box-shadow", AppStylesTokens.SHADOW_BUBBLE_AI)
    }

    val thinkingDots by style {
        display(DisplayStyle.LegacyInlineFlex)
        alignItems(AlignItems.Center)
        gap(2.px)
        marginLeft(4.px)
        lineHeight("1")
    }

    val thinkingDot by style {
        fontSize(12.px)
        opacity(0.25)
        property("animation", "${AppStylesAnimations.thinkingPulse.name} 1.25s ease-in-out infinite")
        property("transform", "translateY(-0.5px)")
    }

    val thinkingDot1 by style { property("animation-delay", "0ms") }
    val thinkingDot2 by style { property("animation-delay", "180ms") }
    val thinkingDot3 by style { property("animation-delay", "360ms") }

    val bubbleAIInteractive by style {
        property("transition", "transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease")
        self + hover style {
            property("transform", "translateY(-1px)")
            border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.14))
            property("box-shadow", AppStylesTokens.SHADOW_BUBBLE_AI_HOVER)
        }
        self + active style { property("transform", "translateY(0)") }
    }

    val bubbleAIRegenerating by style {
        border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.14))
        property("box-shadow", "0 12px 30px rgba(15,23,42,0.045), inset 0 1px 0 rgba(243,242,255,0.95)")
    }

    // ----- Zone éditable (brouillon) : top row + zone éditeur, bordure violette
    val bubbleDraft by style {
        width(100.percent)
        borderRadius(16.px)
        padding(0.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        position(Position.Relative)
        overflow("hidden")
        border(1.6.px, LineStyle.Solid, rgba(102, 96, 230, 0.50))
        backgroundColor(Color("#F3F2FF"))//rgba(248, 247, 255, 0.80))
        property("box-shadow", "none")
        property("transition", "border-color 180ms ease")
        property("cursor", "text")
    }

    /** Top row : label Réponse + hint, boutons × ↻ à droite (ancrage visuel clair) */
    val bubbleDraftTopRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(12.px)
        padding(14.px, 16.px, 10.px)
        //property("border-bottom", "1px solid rgba(15,23,42,0.06)")
        flexShrink(0)
    }

    val bubbleDraftTopRowLeft by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Baseline)
        gap(10.px)
        minWidth(0.px)
    }

    val bubbleDraftTopRowLabel by style {
        fontSize(13.px)
        fontWeight(600)
        property("letter-spacing", "-0.01em")
        color(rgba(15, 23, 42, 0.92))
    }

    val bubbleDraftTopRowHint by style {
        fontSize(13.px)
        color(rgba(15, 23, 42, 0.55))
        whiteSpace("nowrap")
        overflow("hidden")
        property("text-overflow", "ellipsis")
        property("max-width", "64ch")
    }

    val bubbleDraftTopRowActions by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
        flexShrink(0)
    }

    /** Boutons × ↻ du header (32px, alignés sur la top row) */
    val bubbleDraftTopRowBtn by style {
        width(32.px)
        height(32.px)
        borderRadius(12.px)
        border(1.px, LineStyle.Solid, rgba(15, 23, 42, 0.08))
        backgroundColor(rgba(255, 255, 255, 0.8))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        fontSize(15.px)
        fontWeight(800)
        property("transition", "transform 140ms ease, background 140ms ease, border-color 140ms ease")
        self + hover style {
            property("transform", "translateY(-1px)")
            backgroundColor(rgba(15, 23, 42, 0.03))
            property("border-color", "rgba(15,23,42,0.10)")
            property("box-shadow", "0 10px 18px rgba(17,24,39,0.08)")
        }
        self + disabled style {
            opacity(0.5)
            cursor("not-allowed")
            property("transform", "none")
        }
    }

    val bubbleDraftTopRowBtnDanger by style {
        color(rgba(200, 55, 80, 0.85))
        property("border-color", "rgba(200, 55, 80, 0.18)")
    }

    val bubbleDraftTopRowBtnBrand by style {
        color(rgba(102, 96, 230, 0.88))
        property("border-color", "rgba(102, 96, 230, 0.18)")
    }

    /** Conteneur zone éditeur (padding 0 16 12) */
    val bubbleDraftEditorWrap by style {
        padding(0.px, 16.px, 12.px)
        flexShrink(0)
    }

    /** État focus : accent bordure uniquement (pas de halo violet) */
    val bubbleDraftFocused by style {
        border(1.6.px, LineStyle.Solid, rgba(102, 96, 230, 0.68))
        property("box-shadow", "none")
    }

    /** Survol sans focus : bordure violette légèrement renforcée */
    val bubbleDraftHoverable by style {
        self + hover style {
            border(1.6.px, LineStyle.Solid, rgba(102, 96, 230, 0.58))
        }
    }

    /** Overlay discret : ne doit pas bloquer les clics sur la zone de saisie. pointer-events: none sur le conteneur. */
    val bubbleDraftOverlayActions by style {
        position(Position.Absolute)
        top(12.px)
        left(12.px)
        right(12.px)
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.FlexEnd)
        alignItems(AlignItems.Center)
        gap(8.px)
        property("z-index", "5")
        property("pointer-events", "none")
    }

    val bubbleDraftOverlayLabel by style {
        fontSize(13.px)
        fontWeight(600)
        color(rgba(15, 23, 42, 0.62))
        marginRight(4.px)
    }

    /** Seuls les boutons et le label reprennent les clics pour ne pas bloquer le textarea. */
    val bubbleDraftOverlayButtons by style {
        display(DisplayStyle.Flex)
        gap(8.px)
        alignItems(AlignItems.Center)
        property("pointer-events", "auto")
    }

    val bubbleDraftInteractive by style {
        property("transition", "transform 140ms ease, border-color 140ms ease")
        self + hover style {
            property("transform", "translateY(-1px)")
            border(1.6.px, LineStyle.Solid, rgba(102, 96, 230, 0.62))
            property("box-shadow", "none")
        }
        self + active style { property("transform", "translateY(0)") }
    }

    val bubbleDraftRegenerating by style {
        border(1.6.px, LineStyle.Solid, rgba(102, 96, 230, 0.42))
        property("box-shadow", "none")
    }

    /** Overlay violet Appsyde flouté pendant le drag (toute la zone = drop zone) */
    val bubbleDraftDropOverlay by style {
        position(Position.Absolute)
        property("inset", "0")
        property("z-index", "10")
        borderRadius(16.px)
        property("background", "rgba(102, 96, 230, 0.42)")
        property("backdrop-filter", "blur(12px)")
        property("-webkit-backdrop-filter", "blur(12px)")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        property("pointer-events", "none")
    }

    /** Grand plus au centre de l'overlay drag */
    val bubbleDraftDropOverlayPlus by style {
        color(Color.white)
        fontSize(72.px)
        fontWeight(200)
        property("line-height", "1")
        opacity(0.95)
    }

    /** Zone container : fond violet léger, bordure violette — crée la profondeur */
    val bubbleGrowingContainer by style {
        width(100.percent)
        position(Position.Relative)
        backgroundColor(Color("#F8F7FF"))
        border(1.px, LineStyle.Solid, Color("#DCD8FF"))
        borderRadius(10.px)
        padding(12.px)
    }

    /** Champ blanc à l’intérieur : textarea sur fond blanc, radius 8px, padding 12px */
    val bubbleEditorInnerBox by style {
        display(DisplayStyle.Grid)
        gridTemplateColumns("minmax(0, 1fr)")
        width(100.percent)
        minHeight(80.px)
        position(Position.Relative)
        backgroundColor(rgba(255, 255, 255, 0.60))//rgba(248, 247, 255, 0.80))
        borderRadius(8.px)
        padding(12.px)
        overflow("hidden")
    }

    val bubbleContent by style {
        // ✅ typo lecture-first (sans changer le reste de l'UI)
        property("font-family", FONT_FAMILY)
        fontSize(16.px)
        property("line-height", "1.62")
        fontWeight(450)                          // ✅ moins “gras” visuellement
        property("letter-spacing", "0")          // ✅ stop le -0.01em (fatiguant)
        color(rgba(15, 23, 42, 0.88))            // contraste lecture confortable

        // ✅ rendering
        property("text-rendering", "optimizeLegibility")
        property("-webkit-font-smoothing", "antialiased")
        property("-moz-osx-font-smoothing", "grayscale")
        // Inter aime bien ces features pour le texte
        property("font-feature-settings", "\"cv11\" 1, \"ss01\" 1, \"liga\" 1, \"calt\" 1")

         minHeight(54.px)

        whiteSpace("pre-wrap")
        property("overflow-wrap", "anywhere")
        property("word-break", "break-word")
        overflowY("auto")
    }

    /** Texte du message client : après bubbleContent pour override couleur uniquement. */
    val bubbleClientContent by style {
        color(rgba(15, 23, 42, 0.94))
    }

    /** Un paragraphe du message client : espacement fixe 18px entre paragraphes (au lieu d’un saut de ligne complet). */
    val bubbleClientParagraph by style {
        property("margin-bottom", "24px")
    }

    /** Dernier paragraphe : pas de marge en bas. */
    val bubbleClientParagraphLast by style {
        property("margin-bottom", "0")
    }

    /** Ligne dédiée pour le bouton signature (sur une autre ligne que le texte). */
    val bubbleClientSignatureRow by style {
        display(DisplayStyle.Block)
        property("margin-top", "12px")
    }

    /** Bouton « … » pour afficher la signature retirée. */
    val bubbleClientSignatureToggle by style {
        padding(2.px, 6.px)
        fontSize(13.px)
        fontWeight(500)
        color(rgba(102, 96, 230, 0.78))
        backgroundColor(Color.transparent)
        border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.22))
        borderRadius(6.px)
        property("cursor", "pointer")
        self + hover style {
            color(rgba(102, 96, 230, 0.95))
            border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.4))
        }
    }

    /** Bloc signature affiché sous le message (après clic sur « … »). */
    val bubbleClientSignatureBlock by style {
        property("margin-top", "10px")
        paddingTop(10.px)
        property("border-top", "1px solid rgba(15, 23, 42, 0.12)")
        fontSize(14.px)
        property("line-height", "1.5")
        color(rgba(15, 23, 42, 0.72))
        whiteSpace("pre-wrap")
        property("word-break", "break-word")
    }

    val bubbleGhostArea by style {
        gridArea("1 / 1 / 2 / 2")
        visibility(VisibilityStyle("hidden"))
        whiteSpace("pre-wrap")
        property("word-break", "break-word")

        // ✅ copie EXACTE de l'editable (important pour l'autogrow)
        property("font-family", FONT_FAMILY)
        fontSize(15.5.px)
        property("line-height", "1.62")
        fontWeight(400)
        property("letter-spacing", "0")
        minHeight(54.px)
        padding(0.px)
    }
    val bubbleCounterOverlay by style {
        property("position", "absolute")
        property("right", "12px")
        property("bottom", "8px")
        property("pointer-events", "none")
        property("z-index", "2")
    }

    /** Ligne en bas de la bulle : plus d’espace au-dessus (séparation claire), Envoyer intégré et aligné à droite */
    val bubbleFooterRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        padding(4.px, 16.px, 14.px)
        marginTop(2.px)
        borderRadius(0.px)
        minWidth(0.px)
    }

    /** Row interne du footer : prend l’espace restant pour séparer au max Grammaire/Ton (gauche) et pièce jointe/Envoyer (droite). */
    val bubbleFooterRowInner by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.Center)
        flex(1)
        minWidth(0.px)
    }

    val bubbleFooterCharCount by style {
        fontSize(11.px)
        fontWeight(500)
        color(rgba(15, 23, 42, 0.52))
        property("letter-spacing", "0.02em")
    }

    /** Conteneur des boutons d’ajustement (Grammaire, Ton pro) dans le footer de la bulle */
    val bubbleFooterActions by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
    }

    /** Chips Grammaire / Ton pro en style ghost ; désactivé = plus lisible (opacité 0,62, texte gris) */
    val bubbleFooterChipGhost by style {
        borderRadius(AppStylesTokens.RADIUS_PILL.px)
        padding(5.px, 10.px)
        fontSize(12.px)
        fontWeight(550)
        backgroundColor(Color.transparent)
        color(rgba(102, 96, 230, 0.82))
        border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.12))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(6.px)
        property("transition", "background 140ms ease, border-color 140ms ease, color 140ms ease")
        self + hover style {
            backgroundColor(rgba(102, 96, 230, 0.06))
            border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.22))
            color(rgba(102, 96, 230, 0.92))
        }
        self + active style { backgroundColor(rgba(102, 96, 230, 0.04)) }
        self + disabled style {
            opacity(0.62)
            color(rgba(15, 23, 42, 0.48))
            property("border-color", "rgba(15,23,42,0.10)")
            cursor("not-allowed")
        }
    }
    /** Chip primaire « Réponse suggérée » : fond violet léger V2, texte violet saturé */
    val bubbleFooterChipGhostStrong by style {
        borderRadius(AppStylesTokens.RADIUS_PILL.px)
        padding(6.px, 14.px)
        fontSize(12.px)
        fontWeight(700)
        backgroundColor(Color("#ECEBFF"))
        color(rgba(91, 92, 230, 0.95))
        marginRight(10.px)
        border(1.px, LineStyle.Solid, Color("#DAD8FF"))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(6.px)
        property("transition", "background 140ms ease, border-color 140ms ease, color 140ms ease, box-shadow 140ms ease")
        self + hover style {
            backgroundColor(Color("#E5E4FF"))
            border(1.px, LineStyle.Solid, Color("#C9C7FF"))
            color(rgba(91, 92, 230, 0.98))
            property("box-shadow", "0 10px 18px rgba(91,92,230,0.12)")
        }
        self + active style { backgroundColor(Color("#DFDEFF")) }
        self + disabled style {
            opacity(0.5)
            cursor("not-allowed")
        }
    }
    val bubbleEditableArea by style {
        gridArea("1 / 1 / 2 / 2")
        width(100.percent)
        height(100.percent)
        backgroundColor(Color.transparent)
        border(0.px)
        outline("none")

        // ✅ ne pas dépendre de "inherit" ici : on force la typo lecture
        property("font-family", FONT_FAMILY)
        fontSize(15.5.px)
        property("line-height", "1.62")
        fontWeight(400)
        property("letter-spacing", "0")
        color(rgba(15, 23, 42, 0.88))

        // ✅ rendering
        property("text-rendering", "optimizeLegibility")
        property("-webkit-font-smoothing", "antialiased")
        property("-moz-osx-font-smoothing", "grayscale")
        property("font-feature-settings", "\"cv11\" 1, \"ss01\" 1, \"liga\" 1, \"calt\" 1")

        property("caret-color", AppStylesTokens.PURPLE)
        property("resize", "none")
        overflow("hidden")
        property("field-sizing", "content")
    }

    val bubbleEditableAreaDimmed by style {
        opacity(0.70)
        property("filter", "saturate(0.92)")
    }

    val aiToolbarBELLOWBubble by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        property("width", "fit-content")
        property("max-width", "100%")
        gap(10.px)
        marginBottom(20.px)
        padding(0.px, 10.px)
        borderRadius(16.px)
    }

    val aiToolbarLeft by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        color(rgba(15, 23, 42, 0.60))
        fontSize(12.5.px)
        fontWeight(600)
        property("letter-spacing", "-0.006em")
    }

    val aiToolbarCenterStart by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        flex(1)
        justifyContent(JustifyContent.FlexStart)
        minWidth(0.px)
    }

    val toolbarChip by style {
        borderRadius(AppStylesTokens.RADIUS_PILL.px)
        padding(6.px, 11.px)
        fontSize(12.5.px)
        fontWeight(550)
        property("letter-spacing", "-0.006em")
        backgroundColor(rgba(255, 255, 255, 0.62))
        color(rgba(102, 96, 230, 0.88))
        property("border", "1px solid rgba(102,96,230,0.11)")
        property("box-shadow", "inset 0 1px 0 rgba(255,255,255,0.86)")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(7.px)
        property("transition", "transform 120ms ease, box-shadow 140ms ease, border-color 140ms ease, background 140ms ease")
        self + hover style {
            property("transform", "translateY(-1px)")
            backgroundColor(rgba(255, 255, 255, 0.80))
            property("box-shadow", "0 10px 22px rgba(15,23,42,0.05), inset 0 1px 0 rgba(255,255,255,0.92)")
        }
        self + active style { property("transform", "translateY(0px)") }
        self + disabled style {
            opacity(0.52)
            cursor("not-allowed")
            property("transform", "none")
        }
    }

    val toolbarChipIcon by style {
        fontSize(12.px)
        opacity(0.82)
        property("transform", "translateY(-0.25px)")
    }

    val toolbarChipLabel by style { whiteSpace("nowrap") }

    val toolbarChipLoading by style {
        backgroundColor(rgba(102, 96, 230, 0.05))
    }

    val toolbarIconButton by style {
        width(34.px)
        height(34.px)
        borderRadius(34.px)
        border(1.px, LineStyle.Solid, rgba(15, 23, 42, 0.08))
        backgroundColor(rgba(255, 255, 255, 0.76))
        color(rgba(15, 23, 42, 0.74))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        fontSize(16.px)
        fontWeight(800)
        property("box-shadow", "inset 0 1px 0 rgba(255,255,255,0.92)")
        property("transition", "transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease, background 120ms ease, color 120ms ease")
        self + hover style {
            property("transform", "translateY(-1px)")
            backgroundColor(rgba(255, 255, 255, 0.92))
            property("border-color", rgba(102, 96, 230, 0.18))
            property("box-shadow", "0 10px 26px rgba(15,23,42,0.06), inset 0 1px 0 rgba(255,255,255,0.96)")
        }
        self + active style { property("transform", "translateY(0px)") }
        self + disabled style {
            opacity(0.50)
            cursor("not-allowed")
            property("transform", "none")
        }
    }

    val toolbarIconButtonDanger by style {
        color(rgba(200, 55, 80, 0.80))
        property("border-color", "rgba(200, 55, 80, 0.16)")
    }

    val toolbarIconButtonBrand by style {
        color(rgba(102, 96, 230, 0.84))
        property("border-color", "rgba(102, 96, 230, 0.16)")
    }

    val toolbarIconButtonSpinning by style {
        property("animation", "${AppStylesAnimations.spin.name} 0.9s linear infinite")
    }

    /** Fond blanc 30 % pour les boutons de la zone d’édition (×, ↻, Grammaire, Ton ; pas Envoyer). !important pour écraser toolbarIconButton / bubbleFooterChipGhost. */
    val bubbleDraftButtonBg by style {
        property("background-color", "rgba(255, 255, 255, 0.30) !important")
    }

    // Pièces jointes (ligne Client · heure · 📎 file1 · file2 · +N)
    val attachmentMetaLine by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        alignItems(AlignItems.Center)
        gap(5.px)
        fontSize(13.px)
        color(rgba(15, 23, 42, 0.62))
        marginBottom(6.px)
    }

    val attachmentSeparator by style {
        opacity(0.5)
        whiteSpace("nowrap")
    }

    /** Icône trombone : plus grande et lisible */
    val attachmentIcon by style {
        fontSize(16.px)
        lineHeight(1.px)
        color(rgba(15, 23, 42, 0.72))
        property("vertical-align", "middle")
    }

    val attachmentLink by style {
        color(rgba(102, 96, 230, 0.95))
        fontWeight(600)
        cursor("pointer")
        property("text-decoration", "none")
        border(0.px)
        background("none")
        padding(0.px)
        fontSize(13.px)
        property("transition", "color 120ms ease")
        self + hover style { color(rgba(102, 96, 230, 1.0)) }
    }

    /** +N pill : fond subtil mais lisible, texte bien contrasté */
    val attachmentPill by style {
        display(DisplayStyle.LegacyInlineFlex)
        alignItems(AlignItems.Center)
        padding(5.px, 9.px)
        borderRadius(6.px)
        backgroundColor(rgba(15, 23, 42, 0.09))
        color(rgba(15, 23, 42, 0.82))
        fontSize(12.5.px)
        fontWeight(600)
        cursor("pointer")
        border(0.px)
        property("transition", "background-color 120ms ease, color 120ms ease")
        self + hover style {
            backgroundColor(rgba(15, 23, 42, 0.14))
            color(rgba(15, 23, 42, 0.95))
        }
    }

    val attachmentExpandable by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        alignItems(AlignItems.Center)
        gap(4.px)
        marginTop(4.px)
    }

    // ---------- Pièces jointes outbound (sous l'éditeur) ; un seul divider avec marges 20px après la zone de saisie ----------
    val outboundAttachmentSection by style {
        marginTop(10.px)
        paddingTop(10.px)
        paddingLeft(20.px)
        paddingRight(20.px)
        position(Position.Relative)
        self + before style {
            property("content", "\"\"")
            property("position", "absolute")
            property("top", "0")
            property("left", "20px")
            property("right", "20px")
            property("height", "1px")
            property("background", "rgba(15,23,42,0.06)")
        }
    }

    val outboundAttachmentTitleRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        fontSize(12.px)
        color(rgba(15, 23, 42, 0.62))
        marginBottom(6.px)
    }

    val outboundAttachmentFileRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        fontSize(13.px)
        color(rgba(15, 23, 42, 0.88))
        padding(4.px, 0.px)
        paddingBottom(10.px)
        minWidth(0.px)
    }

    val outboundAttachmentFileIcon by style {
        flexShrink(0)
        fontSize(14.px)
    }

    val outboundAttachmentFileName by style {
        flex(1)
        overflow("hidden")
        property("text-overflow", "ellipsis")
        whiteSpace("nowrap")
    }

    val outboundAttachmentFileSize by style {
        fontSize(12.px)
        color(rgba(15, 23, 42, 0.52))
    }

    val outboundAttachmentRemoveBtn by style {
        padding(2.px, 6.px)
        fontSize(14.px)
        fontWeight(600)
        color(rgba(15, 23, 42, 0.5))
        backgroundColor(Color.transparent)
        border(0.px)
        cursor("pointer")
        borderRadius(4.px)
        self + hover style { color(rgba(220, 38, 38, 0.9)) }
    }

    val outboundAttachmentDropZone by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        padding(12.px)
        marginTop(6.px)
        borderRadius(6.px)
        border(1.5.px, LineStyle.Dashed, rgba(102, 96, 230, 0.35))
        backgroundColor(rgba(102, 96, 230, 0.04))
        fontSize(12.px)
        color(rgba(102, 96, 230, 0.75))
    }

    val outboundAttachmentAddButton by style {
        padding(6.px, 12.px)
        fontSize(12.px)
        fontWeight(600)
        color(rgba(102, 96, 230, 0.9))
        backgroundColor(rgba(102, 96, 230, 0.08))
        border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.25))
        borderRadius(6.px)
        cursor("pointer")
        self + hover style {
            backgroundColor(rgba(102, 96, 230, 0.12))
            border(1.px, LineStyle.Solid, rgba(102, 96, 230, 0.4))
        }
    }

    val outboundAttachmentErrors by style {
        fontSize(12.px)
        color(rgba(220, 38, 38, 0.9))
        marginTop(6.px)
    }
}
